<ng-template [ngIf]="!loaded" [ngIfElse]="loading">




  <div class="row  justify-content-center">
    <h2 class="col-12 titleBookk bold">{{ 'CONSO.TITLE' | translate }}</h2>

    <mat-card class="col-11 col-md-6">

    <div class="row mt-5">
      <!-- Graphique -->
      <div class="col-md-6 col-12">
        <h3 class="section-title">Répartition de production</h3>
        <div class="chart-container">
          <canvas id="energyChart"></canvas>
        </div>
      </div>

      <!-- Données de conso -->
      <div class="col-md-6 col-12 text-center mt-5 mt-md-0">
        <div class="conso-item">
          <h3>Consommation du mois en cours (kWh)</h3>
          <p class="conso-value">XXXX</p>
        </div>
        <div class="conso-item mt-4">
          <h3>Consommation cumulée (kWh)</h3>
          <p class="conso-value">XXXX</p>
        </div>
      </div>
    </div>


   

    </mat-card>


  </div>








</ng-template>

<ng-template #loading>
  <div class="row">
    loading...
  </div>
</ng-template>